import React from "react";
import { capitalize } from "lodash";
const ClassificationChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "added":
            return (React.createElement(React.Fragment, null,
                "Reproducible build contains a",
                " ",
                React.createElement("strong", null, capitalize(change.current)),
                " file"));
        case "removed":
            return (React.createElement(React.Fragment, null,
                "Reference version contains a",
                " ",
                React.createElement("strong", null, capitalize(change.previous)),
                " file"));
        case "changed":
            return (React.createElement(React.Fragment, null,
                "Reference version file has changed classification from",
                " ",
                React.createElement("strong", null,
                    capitalize(change.previous) || "Unknown",
                    " to",
                    " ",
                    capitalize(change.current)),
                " ",
                "in the reproducible build"));
    }
};
const FormatChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "added":
            return (React.createElement(React.Fragment, null,
                "File in ",
                React.createElement("strong", null, change.current),
                " format appears only in the reproducible build"));
        case "removed":
            return (React.createElement(React.Fragment, null,
                "File in ",
                React.createElement("strong", null, change.previous),
                " format appears only in the reference version"));
        case "changed":
            return (React.createElement(React.Fragment, null,
                "Reference version file has changed format from",
                " ",
                React.createElement("strong", null, change.previous),
                " to",
                " ",
                React.createElement("strong", null, change.current),
                " in the reproducible build"));
    }
};
const FunctionalityChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "changed":
            return React.createElement(React.Fragment, null, "File changed its low-level code signature");
        default:
            return null;
    }
};
const EntropyChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "changed":
            return React.createElement(React.Fragment, null, "File entropy change exceeded the allowed maximum");
        default:
            return null;
    }
};
const HashChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "added":
            return React.createElement(React.Fragment, null, "File appears only in the reproducible build");
        case "removed":
            return React.createElement(React.Fragment, null, "File appears only in the reference version");
        case "changed":
            return React.createElement(React.Fragment, null, "File changed its hash");
    }
};
const BehaviorChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "added":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.current.slice(0, -1)),
                " appears only in the reproducible build"));
        case "removed":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.previous.slice(0, -1)),
                " appears only in the reference version"));
        default:
            return null;
    }
};
const IssueChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "added":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.current.endsWith(".")
                    ? change.current.slice(0, -1)
                    : change.current),
                " ",
                "affects only the reproducible build"));
        case "removed":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.previous.endsWith(".")
                    ? change.previous.slice(0, -1)
                    : change.previous),
                " ",
                "appears only in the reference version"));
        default:
            return null;
    }
};
const TagChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "added":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.current),
                " appears only in the reproducible build"));
        case "removed":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.previous),
                " appears only in the reference version"));
        default:
            return null;
    }
};
const VulnerabilityChangeExplanation = ({ change, }) => {
    switch (change.change) {
        case "added":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.current),
                " affects only the reproducible build"));
        case "removed":
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, change.previous),
                " affects only the reference version"));
        default:
            return null;
    }
};
export const ChangeExplanation = ({ change, diffObjectType, }) => {
    switch (diffObjectType) {
        case "classification":
            return React.createElement(ClassificationChangeExplanation, { change: change });
        case "format":
            return React.createElement(FormatChangeExplanation, { change: change });
        case "functionality":
            return React.createElement(FunctionalityChangeExplanation, { change: change });
        case "entropy":
            return React.createElement(EntropyChangeExplanation, { change: change });
        case "hash":
            return React.createElement(HashChangeExplanation, { change: change });
        case "indicator":
            return React.createElement(BehaviorChangeExplanation, { change: change });
        case "policy":
            return React.createElement(IssueChangeExplanation, { change: change });
        case "tag":
            return React.createElement(TagChangeExplanation, { change: change });
        case "vulnerability":
            return React.createElement(VulnerabilityChangeExplanation, { change: change });
        default:
            return null;
    }
};
export default ChangeExplanation;
//# sourceMappingURL=ChangeExplanation.js.map